// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__5-PdC","column":"style_column__2t11R","row":"style_row__3CmCK"};